export default __webpack_public_path__ + "img/9994b600f1dc8f4a2e3b5873d6c949d5.png";